import React, { useState, useRef, useEffect } from "react";
import MenuScreen from "./MenuScreen";
import LoaderScreen from "./LoaderScreen";
import RowList from "./RowList";
// import { fetchContent } from "../services/api";
import AppLanguage from "./AppLanguage";
import TermsConditions from "./TermsConditions";
import PrivacyPolicyComponent from "./PrivacyPolicy";
import AboutUsComponent from "./AboutUs";
import HelpSupportsComponent from "./HelpSupport";
import MyAccount from "./MyAccount";
import SubscriptionRental from "./SubscriptionRental";
import ModalScreen from "./ModalScreen";
import { Translate, Languages } from "./LanguageChanger";

import loginimg from "../assets/loginimg.png";
import solidbackgroundimg from "../assets/solidbackgroundimg.png";
import logoutIcon from "../assets/Logout-Icon.png";
import { getMasterHit } from "../services/services";
import { sendTestMatomoEvent } from "../Analytics/MatomoManager/matomoTest";
import { getMasterHitV2, getReferalResponse } from "../services/services";
import ReferalCode from "./ReferalCode";

let resolution = window.RESOLUTION;

const SettingsScreen = ({ navigate, isLogedIn }) => {
  const lang = localStorage.getItem("AppLanguage");
  const [selectedLanguage, setSelectedLanguage] = useState(lang);
  const ReferalDisplay =
    JSON.parse(localStorage.getItem("masterData"))?.data?.refral?.display === 1
      ? true
      : false;

  console.log("ReferalDisplay", ReferalDisplay);
  const getTranslation = (key) => {
    return Languages[lang]?.[key] || Languages.English[key];
  };

  useEffect(() => {
    // Matomo Event
    sendTestMatomoEvent({
      eventCategory: "Page",
      eventAction: "View",
      eventName: "AppSettings",
      url: "settings",
    });
  }, []);

  const [state, setState] = useState({
    isLogedInUser: false,
    loading: false,
    //{ title: "My Account", id: "myaccount", indx: 0 },
    category: isLogedIn && ReferalDisplay
      ? [
        {
          title: `${getTranslation("my-account")}`,
          id: "myaccount",
          indx: 0,
        },
        {
          title: `${getTranslation("app_language")}`,
          id: "applanguage",
          indx: 1,
        },
        {
          title: `${getTranslation("help_support")}`,
          id: "helpandsupport",
          indx: 2,
        },
        {
          title: `${getTranslation("refer_friend")}`,
          id: "referalcode",
          indx: 3,
        },
        {
          title: `${getTranslation("Term&Conditions")}`,
          id: "termsandcondition",
          indx: 4,
        },
        {
          title: `${getTranslation("privacypolicy")}`,
          id: "privacypolicy",
          indx: 5,
        },
        { title: `${getTranslation("About-Us")}`, id: "aboutus", indx: 6 },
      ]
      : isLogedIn ?
        [
          {
            title: `${getTranslation("my-account")}`,
            id: "myaccount",
            indx: 0,
          },
          {
            title: `${getTranslation("app_language")}`,
            id: "applanguage",
            indx: 1,
          },
          {
            title: `${getTranslation("help_support")}`,
            id: "helpandsupport",
            indx: 2,
          },
          {
            title: `${getTranslation("Term&Conditions")}`,
            id: "termsandcondition",
            indx: 3,
          },
          {
            title: `${getTranslation("privacypolicy")}`,
            id: "privacypolicy",
            indx: 4,
          },
          { title: `${getTranslation("About-Us")}`, id: "aboutus", indx: 5 },
        ]
        : [
          // { title: `${getTranslation('my-account')}`, id: "myaccount", indx: 0 },
          {
            title: `${getTranslation("app_language")}`,
            id: "applanguage",
            indx: 0,
          },
          {
            title: `${getTranslation("help_support")}`,
            id: "helpandsupport",
            indx: 1,
          },
          {
            title: `${getTranslation("Terms-and-Conditions")}`,
            id: "termsandcondition",
            indx: 2,
          },
          {
            title: `${getTranslation("Privacy-Policy")}`,
            id: "privacypolicy",
            indx: 3,
          },
          { title: `${getTranslation("About-Us")}`, id: "aboutus", indx: 4 },
        ],
    masterHit: [],
    referalDataCode: {},
    HelpSupport: "",
    TermsCondition: "",
    PrivacyPolicy: "",
    AboutUs: "",
    ContactUs: "",
    shouldFocusToTermsConditionse: false,
    shouldFocusToPrivacyPolicy: false,
    shouldFocusToAboutUs: false,
    shouldFocusToRowList: true,
    shouldFocusToAppLanguage: false,
    shouldFocusToMyAccount: false,
    shouldFocusToMyReferal: false,
    shouldFocusToHelpSupport: false,
    shouldCloseMenu: true,
    selectedTabindx: 0,
    shouldShowModal: false,
    errTitle: "",
    errDescription: "",
    errIcon: "",
    button: ["Logout", "Cancel"],
    iconWdth: "",
    iconHeight: "",
  });
  const {
    isLogedInUser,
    loading,
    category,
    masterHit,
    referalDataCode,
    HelpSupport,
    TermsCondition,
    PrivacyPolicy,
    AboutUs,
    ContactUs,
    shouldFocusToTermsConditionse,
    shouldFocusToPrivacyPolicy,
    shouldFocusToAboutUs,
    shouldFocusToRowList,
    shouldFocusToAppLanguage,
    shouldFocusToMyAccount,
    shouldFocusToMyReferal,
    shouldFocusToHelpSupport,
    shouldCloseMenu,
    selectedTabindx,
    shouldShowModal,
    errTitle,
    errDescription,
    errIcon,
    button,
    iconWdth,
    iconHeight,
    shouldUpFocus,
  } = state;
  const [screen, setScreen] = useState();
  const [data, setData] = useState({});
  const navigateToScreen = (screen, data = {}) => {
    setScreen(screen);
    setData(data);
  };
    const [focusState, setFocusState] = useState({
    shouldFocusToTermsConditionse: false, // Whether to focus on TermsConditions
    shouldFocusToRowList: true, // Whether to focus on RowList
  });


  const handleRightButton = () => {
    console.log("handleRightButton....");
    setState((prevState) => ({
      ...prevState,
      shouldFocusToRowList: true,
      shouldCloseMenu: true,
    }));
    MenuScreen.SetFocus(true);
    //navigate("CategoryScreen");
  };
  const handleExit = () => {
    setState((prevState) => ({
      ...prevState,
      shouldCloseMenu: true,
      shouldShowModal: true,
      errTitle: "Exit",
      errDescription: "ExitMsg",
      errIcon: logoutIcon,
      iconWdth: "109px",
      iconHeight: "109px",
      button: ["Yes", "No"],
    }));
    MenuScreen.SetFocus(true);
  };
  const RowlListcallBack = (SeletedItem) => {
    // if (SeletedItem.id === "myaccount") {
    //   setState((prevState) => ({
    //     ...prevState,
    //     selectedTabindx: SeletedItem.indx,
    //   }));
    // } else if (SeletedItem.id === "applanguage") {
    //   setState((prevState) => ({
    //     ...prevState,
    //     selectedTabindx: SeletedItem.indx,
    //      shouldFocusToRowList: false,
    // shouldFocusToAppLanguage: true,
    //   }));
    // } else 
    if (SeletedItem.id === "helpandsupport") {      //KrishnaVensysco
        setState((prevState) => ({
            ...prevState,
            // HelpSupport: masterHit.static_pages[3].description,
            HelpSupport: masterHit.static_pages?.[3]?.description || "",
            selectedTabindx: SeletedItem.indx,
        }));
    } else if (SeletedItem.id === "termsandcondition") {
        setState((prevState) => ({
            ...prevState,
            TermsCondition: masterHit.static_pages[2].description || "",
            selectedTabindx: SeletedItem.indx,
        }));
    } else if (SeletedItem.id === "privacypolicy") {
        try {
            setState((prevState) => ({
                ...prevState,
                PrivacyPolicy: masterHit.static_pages[1].description || "",
                selectedTabindx: SeletedItem.indx,
            }));
        } catch (e) { }
    } else if (SeletedItem.id === "aboutus") {
        setState((prevState) => ({
            ...prevState,
            AboutUs: masterHit.static_pages[0].description,
            selectedTabindx: SeletedItem.indx,
        }));
    }
    // else if (SeletedItem.id === "helpandsupport") {      //KrishnaVensysco
    //   setState((prevState) => ({
    //     ...prevState,
    //     HelpSupport: masterHit.static_pages[3].description,
    //     selectedTabindx: SeletedItem.indx,
    //   }));
    // } else if (SeletedItem.id === "referalcode") {
    //   setState((prevState) => ({
    //     ...prevState,
    //     // HelpSupport: masterHit.refral,
    //     selectedTabindx: SeletedItem.indx,
    //   }));
    // }
    else {
        setState((prevState) => ({
            ...prevState,
            // HelpSupport: masterHit.refral,
            selectedTabindx: SeletedItem.indx,
        }));
    }
    // setState((prevState) => ({
    //   ...prevState,
    //   loading: true,
    //   shouldFocusToRowList: false,
    //   shouldFocusToAppLanguage: false,
    //   selectedTabindx: SeletedItem.indx
    // }));
    //fetchSelectedCatItem(SeletedItem);
  };

  const callBackToSettingPage = () => {
    navigate("HomePage");
    MenuScreen.ReseTfocus(4);
  };
  const handleRowListDownButton = () => {
    const currentTabId = category[selectedTabindx].id;      //KrishnaVensysco
    let focusUpdate = {};

    switch(currentTabId) {
      case "myaccount":
        focusUpdate = { shouldFocusToMyAccount: true };
        break;
      case "applanguage":
        focusUpdate = { shouldFocusToAppLanguage: true };
        break;
      case "helpandsupport":
        focusUpdate = { shouldFocusToHelpSupport: true };
        break;
      case "termsandcondition":
        focusUpdate = { shouldFocusToTermsConditionse: true };
        break;
      case "privacypolicy":
        focusUpdate = { shouldFocusToPrivacyPolicy: true };
        break;
      case "aboutus":
        focusUpdate = { shouldFocusToAboutUs: true };
        break;
      case "referalcode":
        focusUpdate = { shouldFocusToMyReferal: true };
        break;
      default:
        break;
    }
    
    setState((prevState) => ({
      ...prevState,
      shouldFocusToRowList: false,
      // shouldFocusToAppLanguage: true,
      // shouldFocusToTermsConditionse: true,
      ...focusUpdate                                //KrishnaVensysco
    }));
  };

  const sendMatomoEvent = (event) => {
    const { category, action, name } = event;
    console.log("Matomo Event", category, action, name);
    sendTestMatomoEvent({
      eventCategory: category,
      eventAction: action,
      eventName: name,
    });
  };

  const HandleUpBTN = () => {
    console.log("-------HandleUpBTN-------------");
    setState((prevState) => ({
      ...prevState,
      shouldFocusToRowList: true,
      shouldFocusToAppLanguage: false,                //KrishnaVensysco
      shouldFocusToTermsConditionse: false,
      shouldFocusToPrivacyPolicy: false,
      shouldFocusToAboutUs: false,
      shouldFocusToMyAccount: false,
      shouldFocusToMyReferal: false,
      shouldFocusToHelpSupport: false,
    }));
    window.removeEventListener("keydown")
  };

  const HandleDownBTN = () => {
    console.log("-------HandleDownBTN-------------");
    setState((prevState) => ({
      ...prevState,
      shouldFocusToRowList: false,
      shouldFocusToTermsConditionse: true,
    }));
  };

  const handleRowListUpButton = () => {
    setState((prevState) => ({
      ...prevState,
      shouldFocusToRowList: true,
      shouldCloseMenu: true,
      // shouldFocusToAppLanguage: true,
    }));
  };
  const handleBackButton = () => {
    console.log("handlebakcbutton....", shouldFocusToRowList, "clicked");
     
    setState((prevState) => ({
      ...prevState,
      shouldFocus: false,
      shouldFocusToRowList: false,
      shouldFocusToAppLanguage: false,
      shouldCloseMenu: false,
    }));
    MenuScreen.SetFocus(false);
  };
  const handleMenuselection = (selectedMenu) => {
    switch (selectedMenu) {
      case "Login":
        navigate("LoginScreen");
        break;
      case "Profile":
        navigate("ProfileScreen");
        break;
      case "Search":
        navigate("SearchScreen");
        break;
      case "Live":
        navigate("LiveScreen");
        break;
      case "LiveEvents":
        navigate("LiveEventsScreen");
        break;
      case "Home":
        navigate("HomePage");
        break;
      case "Watchlist":
        break;
      case "Categories":
        navigate("CategoryScreen");
        break;
      case "Settings":
        navigate("SettingsScreen");
        break;
      case "Logout":
        break;
      default:
        break;
    }
  };

  const handleLogout = (p) => {
    setState((prevState) => ({
      ...prevState,
      shouldFocusToRowList: false,
      shouldFocusToGrid: false,
      shouldCloseMenu: true,
      shouldShowModal: true,
      errTitle: "Logout",
      errDescription: "cofirm-logout",
      errIcon: logoutIcon,
      iconWdth: "109px",
      iconHeight: "109px",
      button: ["Logout", "Cancel"],
    }));
    MenuScreen.SetFocus(true);
  };

  const handleLogin = (p) => {
    setState((prevState) => ({
      ...prevState,
      shouldFocusToRowList: false,
      shouldFocusToGrid: false,
      shouldCloseMenu: true,
      shouldShowModal: true,
      errTitle: "Login to Continue",
      errDescription: "LoginContinue",
      errIcon: loginimg,
      iconWdth: "109px",
      iconHeight: "109px",
      button: ["Login", "Cancel"],
    }));
    MenuScreen.SetFocus(true);
  };

  const modalOKButtonHandler = (action) => {
    switch (action) {
      case "Login":
        navigate("LoginScreen");
        sendMatomoEvent({
          category: "Page",
          action: "View",
          name: "LoginPopup",
        });
        break;
      case "Logout":
        console.log("Logout....");
        localStorage.removeItem("JWTToken");
        localStorage.removeItem("userInfo");
        const getCountry = localStorage.getItem("country");
        // let headers = {
        //   iskid: "0",
        //   Langid: "1",
        //   "Content-Type": "application/json",
        //   country: getCountry,
        // };
        // Promise.all([fetchContent("/V1/logout", "POST", headers)]);
        localStorage.clear();
        window.appReload();
        MenuScreen.ReseTfocus(4);
        MenuScreen.SetFocus(true);
        handleMenuselection("Login");
        break;
      case "Yes":
        console.log("exit application..");
        exitApplication();
        // window.close();
        break;
      default:
        break;
    }
  };

  const exitApplication = () => {
    if (window.tizen) {
      window.tizen.application.getCurrentApplication().exit();
      sendMatomoEvent({ category: "App", action: "End", name: "" });
    } else {
      window.close();
      sendMatomoEvent({ category: "App", action: "End", name: "" });
    }
  };

  const modalCANCELButtonHandler = () => {
    // MenuScreen.ReseTfocus(-1);
    MenuScreen.ReseTfocus(8);
    setState((prevState) => ({
      ...prevState,
      shouldShowModal: false,
      shouldFocusToRowList: true,
    }));
    sendMatomoEvent({ category: "Page", action: "View", name: "CancelPopup" });
  };






  const handleCallback = ({ focusOnText, focusOnRowList }) => {
    // Update focus states based on child component's feedback
    setFocusState({
      shouldFocusToTermsConditionse: focusOnText,
      shouldFocusToRowList: focusOnRowList,
    });
  };

  const selectedTabContentCallBack = (p) => {
    switch (p) {
      case "HandleUPButton":
        // setState((prevState) => ({
        //   ...prevState,
        //   shouldFocusToRowList: true,
        //   shouldFocusToAppLanguage: false,
        // }));
        HandleUpBTN();                              //KrishnaVensysco
        break;
      default:
        break;
    }
  };
  let hasFetchedData = false;
  let isGridCalled = true;
  const loadData = async () => {
    if (hasFetchedData) return;
    setState((prevState) => ({
      ...prevState,
      loading: true,
    }));
    hasFetchedData = true;
    if (!isGridCalled) return;
    const getCountry = localStorage.getItem("country");

    let headers = {
      iskid: "0",
      Langid: "1",
      "Content-Type": "application/json",
      country: getCountry,
      age: "12",
    };

    try {
      // const [fetchedMasterHit] = await Promise.all([
      //   fetchContent("/V1/getMasterHit", "GET", headers),
      // ]);

      const fetchedMasterHit = await getMasterHitV2()

      console.log("masterHit data...", fetchedMasterHit);

      isGridCalled = false;
      setState((prevState) => ({
        ...prevState,
        loading: false,
        masterHit: fetchedMasterHit.data,
      }));

      // console.log("AppSettings1");
      // Matomo Event
      sendMatomoEvent({
        category: "Page",
        action: "View",
        name: "AppSettings",
      });
    } catch (error) {
      console.error("Error fetching data:", error);
      setState((prevState) => ({
        ...prevState,
        loading: false,
      }));
      isGridCalled = false;
    }
  };

  const ReferalData = async () => {
    console.log("ReferalData called...");
    setState((prevState) => ({
      ...prevState,
      loading: true,
    }));
    const getCountry = localStorage.getItem("country");
    const userId = localStorage.getItem("userId");

    let headers = {
      iskid: "0",
      Langid: "1",
      "Content-Type": "application/json",
      country: getCountry,
      age: "12",
    };

    try {
      // const [fetchedMasterHit] = await Promise.all([
      //   fetchContent("/V1/getMasterHit", "GET", headers),
      // ]);

      const ReferalDataResponse = await getReferalResponse(userId)

      console.log("ReferalData data...", ReferalDataResponse);

      isGridCalled = false;
      setState((prevState) => ({
        ...prevState,
        loading: false,
        referalDataCode: ReferalDataResponse.data,
      }));
    } catch (error) {
      console.error("Error fetching data:", error);
      setState((prevState) => ({
        ...prevState,
        loading: false,
      }));
      isGridCalled = false;
    }
  };

  useEffect(() => {
    loadData();
    ReferalData();
    return () => {};
  }, []);
  let SelectedTabContent;

  if (category[selectedTabindx].id === "myaccount" && isLogedIn) {
    SelectedTabContent = (
      <MyAccount
        shouldFocus={shouldFocusToMyAccount}
        callback={selectedTabContentCallBack}
        callback1={selectedTabContentCallBack}
      />
    );
  }
  // else if (category[selectedTabindx].id === "subscriptionrental") {
  //   SelectedTabContent = (
  //     <SubscriptionRental callback={selectedTabContentCallBack} />
  //   );
  // }
  else if (category[selectedTabindx].id === "applanguage") {
    SelectedTabContent = (
      <AppLanguage
        callback={selectedTabContentCallBack}
        shouldFocus={shouldFocusToAppLanguage}
        callback1={selectedTabContentCallBack}
        callBackToSettingPage={callBackToSettingPage}
      />
    );
  } else if (category[selectedTabindx].id === "termsandcondition") {
    SelectedTabContent =
      (console.log(shouldFocusToRowList, shouldUpFocus),
        (
          <TermsConditions
            callback={handleCallback}
            shouldCloseMenu={shouldCloseMenu}
            // callback={selectedTabContentCallBack}
            shouldFocus={shouldFocusToTermsConditionse}
            shouldUpFocus={shouldFocusToRowList}
            HandleUpBTN={HandleUpBTN}
            HandleDownBTN={HandleDownBTN}
            data={TermsCondition}
          // shouldCloseMenu={shouldCloseMenu}
          />
        ));
  } else if (category[selectedTabindx].id === "privacypolicy") {
    SelectedTabContent = (
      <PrivacyPolicyComponent
        callback={selectedTabContentCallBack}
        shouldCloseMenu={shouldCloseMenu}
        shouldFocus={shouldFocusToPrivacyPolicy}
        data={PrivacyPolicy}
        HandleUpBTN={HandleUpBTN}
        HandleDownBTN={HandleDownBTN}
      // shouldCloseMenu={shouldCloseMenu}
      />
    );
  } else if (category[selectedTabindx].id === "aboutus") {
    SelectedTabContent = (
      <AboutUsComponent
        callback={selectedTabContentCallBack}
        shouldFocus={shouldFocusToAboutUs}
        data={AboutUs}
        HandleUpBTN={HandleUpBTN}
        HandleDownBTN={HandleDownBTN}
        shouldCloseMenu={shouldCloseMenu}
      />
    );
  } else if (category[selectedTabindx].id === "helpandsupport") {
    SelectedTabContent =
      (console.log(HelpSupport),
        (
          <HelpSupportsComponent
            callback={selectedTabContentCallBack}
            shouldFocus={shouldFocusToHelpSupport}
            isLogedIn={isLogedIn}
          // data={HelpSupport}
        />
      ));
  } else if (category[selectedTabindx].id === "referalcode") {
    SelectedTabContent =
      (console.log(referalDataCode),
        (
          <ReferalCode
            shouldFocus={shouldFocusToMyReferal}
            callback={selectedTabContentCallBack}
            masterHit={masterHit}
            referalDataCode={referalDataCode}
          // shouldFocus={shouldFocusToHelpSupport}
          // isLogedIn={isLogedIn}
          // data={HelpSupport}
        />
      ));
  }
  const hoverablePages = ['applanguage', 'termsandcondition', 'privacypolicy', 'aboutus'];            //KrishnaVensysco

  return (
    <div style={styles.settingsContainer}>
      {loading && <LoaderScreen />}

      <div
        style={{
          backgroundImage: `url(${solidbackgroundimg})`,
          fontSize: "40px",
          textAlign: "center",
          alignItems: "center",
          position: "absolute",
          height: "78px",
          width: "1890px",
          color: "#FFFFFF", //#0E1653
          background: "transparent",
          marginTop: "30px",
          overflow: "none",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* Settings */}
        <Translate langKey={"settings"} />
      </div>
      <div
        style={{
          backgroundImage: `url(${solidbackgroundimg})`,
          position: "absolute",
          width: "1830px",
          height: "940px",
          // background: "#000000",
          marginLeft: "85px",
          marginTop: "138px",
        }}
        // onMouseEnter={() => setState(prevState => ({...prevState, shouldFocusToRowList: true          
        // }))}
        // onMouseLeave={() => setState(prevState => ({...prevState, shouldFocusToRowList: false}))}
      >
        <div                                  //KrishnaVensysco
          onMouseEnter={() => {
            const currentTabId = category[selectedTabindx].id;
            if (hoverablePages.includes(currentTabId) && !shouldFocusToRowList) {
                HandleUpBTN();
            }
          }}
        >
        <RowList
          borderRadius={"7px"}
          rowWidth="1802px"
          rowHeight="70px"
          columnWidth="340px"
          columnHeight="70px"
          itemWidth="340px"
          itemHeight="70px"
          animationSpeed={300}
          bgColor="transparent"
          shouldFocus={shouldFocusToRowList}
          shouldFocusToRowList={shouldFocusToRowList}
          borderBottom="5px solid #EC008C"
          marginLeft="20px"
          marginTop="0px"
          borderColor={shouldFocusToRowList ? "#EC008C" : "transparent"}
          fontSize="26px"
          fontColor="#FFFFFF"
          selectionStyle="background"
          gapBetweenColumn={10}
          data={category !== null ? category : []}
          shouldUpFocus={shouldFocusToRowList}
          RowlListcallBack={RowlListcallBack}
          handleBackButton={handleBackButton}
          handleRowListDownButton={handleRowListDownButton}
          handleRowListUpButton={handleRowListUpButton}
          activeStyle={"underline"}
          screen={"SettingsScreen"}
        />
        </div>
        <div                                              //KrishnaVensysco
          style={styles.contentArea} 
          onMouseEnter={() => {
            const currentTabId = category[selectedTabindx].id;
            if (hoverablePages.includes(currentTabId) && shouldFocusToRowList) {
                handleRowListDownButton();
            }
          }}
        >
          {SelectedTabContent}
        </div>
      </div>
      <MenuScreen
        navigate={navigateToScreen}
        handleMenuselection={handleMenuselection}
        shouldCloseMenu={shouldCloseMenu}
        handleRightButton={handleRightButton}
        isLogedIn={isLogedIn}
        appNavigate={navigate}
        handleLogin={handleLogin}
        handleLogout={handleLogout}
        handleExit={handleExit}
      />
      <ModalScreen
        shouldShowError={shouldShowModal}
        errTitle={errTitle}
        errDescription={errDescription}
        errIcon={errIcon}
        button={button}
        iconWdth={iconWdth}
        iconHeight={iconHeight}
        modalOKButtonHandler={modalOKButtonHandler}
        modalCANCELButtonHandler={modalCANCELButtonHandler}
      />
    </div>
  );
};

const styles = {
  settingsContainer: {
    backgroundImage: `url(${solidbackgroundimg})`,
    display: "flex",
    flexDirection: "column",
    background: "#000037",
    width: "100vw",
    height: "100vh",
    backgroundSize: "cover",
    backgroundPosition: "center", // Center the background image
    backgroundRepeat: "no-repeat", // Do not repeat the background image
    position: "absolute",
    overflow: "hidden",
  },
  contentArea: {
    display: "flex",
    flexDirection: "column",
    height: "850px",
    width: "1800px",
    overflow: "hidden !important",
    marginLeft: "30px",
    marginTop: "20px",
    // background: "#0E1653",
    position: "absolute",
  },
};
export default SettingsScreen;